import { Grid } from "@mui/material";
import { Button, SelectOption } from "src/UIKit";
import React, { FC } from "react";
import { FormDropdown } from "src/components/FormPart/FormDropdown";
import { FormNumberInput } from "src/components/FormPart/FormNumberInput";
import { FormTextInput } from "src/components/FormPart/FormTextInput";
import { FormComponentProps } from "src/components/FormPart/types";
import { Application } from "src/modules/applications/types";
import { PlanFormData } from "../../types";

type CreateAdminPlanFormProps = {
  applicationOptions: SelectOption<string, string, Application>[];
};

export const CreateAdminPlanForm: FC<FormComponentProps<PlanFormData, CreateAdminPlanFormProps>> = (props) => {
  const { form, applicationOptions } = props;

  const { id } = form.watch();

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormDropdown
          form={form}
          fieldName="applicationId"
          label="Application"
          placeholder="Enter Application"
          options={applicationOptions}
          disabled={!!id}
          validation={{
            required: "Application is required",
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FormTextInput
          form={form}
          fieldName="name"
          label="Plan Name"
          placeholder="Enter Plan Name"
          validation={{
            required: "Plan Name is required",
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FormDropdown
          form={form}
          fieldName="type"
          label="Plan Type"
          placeholder="Enter Plan Type"
          options={[
            { title: "Public", value: "public" },
            { title: "Private", value: "private" },
          ]}
          validation={{
            required: "Plan Type is required",
          }}
        />
      </Grid>

      <Grid item xs={12}>
        <FormNumberInput
          form={form}
          fieldName="credits"
          label="Number of Credits"
          placeholder="Enter Number of Credits"
          validation={{
            required: "Number of Credits is required",
          }}
          format={{
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          }}
          min={0}
        />
      </Grid>

      <Grid item xs={12}>
        <FormNumberInput
          form={form}
          fieldName="price"
          label="Plan Price"
          placeholder="Enter Plan Price"
          validation={{
            required: "Plan Price is required",
          }}
          format={{
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }}
          min={0}
        />
      </Grid>

      <Grid item xs={12}>
        <FormNumberInput
          form={form}
          fieldName="pricePerOverageCredit"
          label="Price per Overage Credit"
          placeholder="Enter Price per Overage Credit"
          validation={{
            required: "Price per Overage Credit is required",
          }}
          format={{
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 4,
            minimumFractionDigits: 2,
          }}
          min={0}
        />
      </Grid>

      <Grid item xs={12}>
        <FormDropdown
          form={form}
          fieldName="chargeIncomingMessages"
          label="Charge for Inbound Messages"
          options={[
            { title: "True", value: "true" },
            { title: "False", value: "false" },
          ]}
        />
      </Grid>

      <Grid item xs={6}>
        <FormNumberInput
          form={form}
          fieldName="duration"
          label="Duration"
          placeholder="Enter Duration"
          validation={{
            required: "Duration is required",
          }}
          format={{
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          }}
          min={0}
        />
      </Grid>

      <Grid item xs={6}>
        <FormDropdown
          form={form}
          fieldName="period"
          label="Period"
          options={[
            { title: "Day", value: "day" },
            { title: "Week", value: "week" },
            { title: "Month", value: "month" },
            { title: "Year", value: "year" },
          ]}
        />
      </Grid>

      <Grid item xs={12}>
        <Button
          type="submit"
          disabled={form.formState.isSubmitting}
          variant="contained"
          color="secondary"
          size="medium"
          fullWidth
        >
          {id ? "Update" : "Create"}
        </Button>
      </Grid>
    </Grid>
  );
};
